import { cn as packageCn, en as packageEn, jp as packageJp, tw as packageTw } from '@eureka/utils/package-locale';

export const cn = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '查看全部 →',
        ...packageCn,
    },
}

export const en = {
    PtUserBanner: {
        endTime: 'Expiration Date: {date}',
        more: 'More →',
        ...packageEn,
    },
}

export const jp = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '続き →',
        ...packageJp,
    },
}

export const tw = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '檢視全部 →',
        ...packageTw,
    },
}
